



























import { Prop, Component, Vue } from "vue-property-decorator";
import _ from "lodash";
import format from "date-fns/format";
import locale from "date-fns/locale/ja";
import {
  Report,
  ReportScene,
  getEntriesInCurrentFolder,
  deleteReportEntry
} from "@/api/report-api";
import { FolderEntry } from "@/models/file";

import VDelete from "@/components/VDelete.vue";
import download from "../helpers/download";

@Component({
  components: {
    VDelete
  }
})
export default class ReportShowPage extends Vue {
  @Prop({ required: true }) projectId!: string;
  @Prop({ required: true }) folderId!: string;
  @Prop({ required: true }) reportId!: string;

  // TODO プロジェクトの情報も必要

  get scenesPerPage() {
    if (!this.report) return [];
    return _.chunk(this.report.scenes, 4);
  }

  canWriteReport() {
    return (
      this.permissions.includes("project/document_secret") ||
      this.permissions.includes("service/project_operation")
    );
  }

  sceneImage(scene: ReportScene) {
    return scene.imageURL || "https://fakeimg.pl/288x180/";
  }

  sceneDate(scene: ReportScene) {
    if (!scene.date) return "";
    return format(scene.date, "PPP", { locale });
  }

  download() {
    if (!this.report) throw new Error("report is not found.");
    download(this.report.pdf, "新しい報告書.pdf");
  }

  async remove() {
    if (!this.report) return;
    await deleteReportEntry(this.report.entryId);
    this.goListPage();
  }

  goListPage() {
    const params = {
      projectId: this.projectId,
      folderId: this.folderId
    };
    this.$router.push({ name: "report-list", params });
  }

  goEditPage() {
    const params = {
      projectId: this.projectId,
      folderId: this.folderId,
      reportId: this.reportId
    };
    this.$router.push({ name: "report-edit", params });
  }

  private report: Report | null = null;
  private reports: FolderEntry[] = [];

  private get permissions(): string[] {
    return this.$store.getters.permissions;
  }

  private async created() {
    await this.initReportList();
    this.initReport();
  }

  private async initReportList() {
    const { entries } = await getEntriesInCurrentFolder(
      this.projectId,
      this.folderId
    );
    this.reports = entries;
  }

  private initReport() {
    const report = this.reports.find(r => String(r.entryId) === this.reportId);
    if (report) {
      this.report = report as Report;
    } else {
      throw new Error("report is not found");
    }
  }
}
